import invariant from 'invariant';

function hasStore(store, duckType) {
    invariant(
        store,
        `
        ${duckType} requires a store name to be assigned. Most likely you forgot to declare the store option in it's creator.
        https://pages.ghe.coxautoinc.com/Autotrader/modular-redux/docs/duck-store#duckstore
        `
    );
}

export { hasStore as default };
